import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';
import { Skin, skinStorage } from './utility/LocalStorage';

smoothscroll.polyfill();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
const rootElement = document.getElementById('root');
const paths = {
  customer: 'player',
  admin: 'admin',
  social: 'social',
  internalAdmin: 'internal-admin',
};
const { pathname, search } = document.location;
const subdirectory = pathname.split('/')[1];

const searchParams = new URLSearchParams(search);
const skinParam = searchParams.get('sk') as Skin | null;

skinStorage.get().then((skin) => {
  if (!!skinParam) {
    skinStorage.set(skinParam);
    skin = skinParam;
  }
  const CustomerApp = lazy(() => import('./customer/App'));
  const CustomerCronosApp = lazy(() => import('./customer-cronos/App'));
  const CustomerAppComponent = skin === Skin.Cronos ? CustomerCronosApp : CustomerApp;

  const AdminApp = lazy(() => import('./admin/App'));
  const InternalAdminApp = lazy(() => import('./internalAdmin/App'));
  const SocialApp = lazy(() => import('./social/App'));
  switch (subdirectory) {
    case paths.customer:
      ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
          <Suspense fallback={<></>}>
            <CustomerAppComponent />
          </Suspense>
        </BrowserRouter>,
        rootElement
      );
      break;
    case paths.admin:
      ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
          <Suspense fallback={<></>}>
            <AdminApp />
          </Suspense>
        </BrowserRouter>,
        rootElement
      );
      break;
    case paths.internalAdmin:
      ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
          <Suspense fallback={<></>}>
            <InternalAdminApp />
          </Suspense>
        </BrowserRouter>,
        rootElement
      );
      break;
    case paths.social:
      ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
          <Suspense fallback={<></>}>
            <SocialApp />
          </Suspense>
        </BrowserRouter>,
        rootElement
      );
      break;
    default:
      ReactDOM.render(<div>Error 404: Page not found</div>, rootElement);
  }
});

const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

window.addEventListener('load', setVh);
window.addEventListener('resize', setVh);
